import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {SimpleModal} from '@modules/simple-modal';

/**
 * @summary ShowModal
 * @extends {AoflElement}
 */
@customElement('show-modal')
class ShowModal extends AoflElement {
  /**
   * Creates an instance of ShowModal.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'show-modal';

  @property({type: String})
  ['modal-id'] = '';

  @property({type: Object})
  ['modal-data'] = {};

  clickHandler = (e) => {
    SimpleModal.show(this['modal-id'], this['modal-data'], e); // eslint-disable-line
  };

  keyPressHandler = (e) => {
    if (e.key === 'Enter') {
      this.clickHandler(e);
    }
  };

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.clickHandler);
    this.addEventListener('keypress', this.keyPressHandler);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
    super.disconnectedCallback();
  }
}

export default ShowModal;
